function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import 'isomorphic-fetch';
import ReactHOC from '../../../../common/react-hoc';
import { API_CONFIG } from './../rest-api-config';
var HearingTestInvitationForm = /*#__PURE__*/function (_React$Component) {
  function HearingTestInvitationForm(props) {
    var _this;
    _classCallCheck(this, HearingTestInvitationForm);
    _this = _callSuper(this, HearingTestInvitationForm, [props]);
    _this.state = {
      submitErrors: false
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(HearingTestInvitationForm, _React$Component);
  return _createClass(HearingTestInvitationForm, [{
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;
      event.preventDefault();
      var confirmationUrl = this.props.data.confirmationUrl.text;
      var hearingTestUrl = this.props.data.hearingTestUrl.text;
      var language = this.props.language;
      fetch("".concat(API_CONFIG.URL, "createinvitation/").concat(language), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          RecipientName: this.nameOfTheRecipient.value,
          RecipientEmail: this.emailOfTheRecipient.value,
          SenderName: this.nameOfTheSender.value,
          SenderEmail: this.emailOfTheSender.value,
          Message: this.message.value,
          ConfirmationUrl: confirmationUrl,
          HearingTestUrl: hearingTestUrl
        })
      }).then(function (response) {
        if (response.status === 200) {
          _this2.props.submitCallback(true);
        } else {
          _this2.setState({
            submitErrors: true
          });
        }
      }).catch(function (e) {
        return console.log(e);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var submitErrors = this.state.submitErrors;
      var _this$props$data = this.props.data,
        title = _this$props$data.title,
        description = _this$props$data.description,
        errorTitle = _this$props$data.errorTitle,
        recipientNameLabel = _this$props$data.recipientNameLabel,
        recipientEmailLabel = _this$props$data.recipientEmailLabel,
        senderNameLabel = _this$props$data.senderNameLabel,
        senderEmailLabel = _this$props$data.senderEmailLabel,
        messageLabel = _this$props$data.messageLabel,
        submitButtonLabel = _this$props$data.submitButtonLabel,
        utmTracking = _this$props$data.utmTracking,
        gaCookieId = _this$props$data.gaCookieId,
        trackingCodeOne = _this$props$data.trackingCodeOne,
        trackingCodeTwo = _this$props$data.trackingCodeTwo,
        trackingCodeOneName = _this$props$data.trackingCodeOneName,
        trackingCodeTwoName = _this$props$data.trackingCodeTwoName;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "invitation-header"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "invitation-header-title like-h2"
      }, title.text)), submitErrors ? /*#__PURE__*/React.createElement("div", {
        className: "invitation-form-errors"
      }, /*#__PURE__*/React.createElement("h1", null, errorTitle.text)) : null, /*#__PURE__*/React.createElement("div", {
        className: "invitation-content"
      }, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: description.html
        },
        className: "invitation-header-description"
      }), /*#__PURE__*/React.createElement("form", {
        className: "invitation-form",
        method: "POST",
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "invitation-form-column"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "nameOfTheRecipient"
      }, "*", recipientNameLabel.text), /*#__PURE__*/React.createElement("input", {
        type: "text",
        id: "nameOfTheRecipient",
        name: "nameOfTheRecipient",
        ref: function ref(_ref) {
          _this3.nameOfTheRecipient = _ref;
        },
        required: true,
        className: "form-control"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "emailOfTheRecipient"
      }, "*", recipientEmailLabel.text), /*#__PURE__*/React.createElement("input", {
        type: "email",
        name: "emailOfTheRecipient",
        id: "emailOfTheRecipient",
        ref: function ref(_ref2) {
          _this3.emailOfTheRecipient = _ref2;
        },
        required: true,
        className: "form-control"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "nameOfTheeSender"
      }, "*", senderNameLabel.text), /*#__PURE__*/React.createElement("input", {
        type: "text",
        name: "nameOfTheeSender",
        id: "nameOfTheeSender",
        ref: function ref(_ref3) {
          _this3.nameOfTheSender = _ref3;
        },
        required: true,
        className: "form-control"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "emailOfTheSender"
      }, "*", senderEmailLabel.text), /*#__PURE__*/React.createElement("input", {
        type: "email",
        name: "emailOfTheSender",
        id: "emailOfTheSender",
        ref: function ref(_ref4) {
          _this3.emailOfTheSender = _ref4;
        },
        required: true,
        className: "form-control"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-md-6 col-sm-12 invitation-form-column",
        hidden: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group form-message"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "message"
      }, messageLabel.text), /*#__PURE__*/React.createElement("textarea", {
        id: "message",
        name: "message",
        ref: function ref(_ref5) {
          _this3.message = _ref5;
        },
        className: "form-control",
        defaultValue: "Here\u2019s a link to a free hearing test on the Philips Hearing Solutions website."
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 invitation-form-submit"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "btn like-white-blue-button-large"
      }, submitButtonLabel.text))), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        value: "FATHER",
        name: "relation",
        id: "relation",
        ref: function ref(_ref6) {
          _this3.relation = _ref6;
        }
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        value: utmTracking.text,
        name: "TrackingParameters"
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        value: gaCookieId.text,
        name: "TrackingCID"
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        value: trackingCodeOne.text,
        name: trackingCodeOneName.text
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        value: trackingCodeTwo.text,
        name: trackingCodeTwoName.text
      })))));
    }
  }]);
}(React.Component);
HearingTestInvitationForm.propTypes = {
  language: PropTypes.string.isRequired,
  data: PropTypes.shape({
    confirmationUrl: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    hearingTestUrl: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    title: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    description: PropTypes.shape({
      html: PropTypes.string.isRequired
    }),
    errorTitle: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    recipientNameLabel: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    recipientEmailLabel: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    senderNameLabel: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    senderEmailLabel: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    messageLabel: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    submitButtonLabel: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    utmTracking: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    gaCookieId: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    trackingCodeOne: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    trackingCodeTwo: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    trackingCodeOneName: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    trackingCodeTwoName: PropTypes.shape({
      text: PropTypes.string.isRequired
    }),
    submitCallback: PropTypes.func
  }).isRequired
};
export default ReactHOC(HearingTestInvitationForm);